import { app_version, env, getAtelierHost } from 'config/environment'
import { session } from 'feature/widget/SessionStore'
import { makeAutoObservable, when } from 'mobx'
import { api } from 'store/api'
import { opt } from 'store/opt'
import { Product } from 'type/Product'
import { State } from 'type/state'

function getStableHost(stable: boolean): string {
  if (!env.production) return location.hostname

  const preview = 'window-preview.dresscode.ai'
  if (location.hostname === preview) return preview

  if (env.domain === 'atelier') {
    const host = getAtelierHost(env.frontendUrl)
    if (stable) return `window.${host}`
    else return `window0.${host}`
  }
  if (env.domain === 'dresscode') {
    if (stable) return 'window.dresscode.ai'
    else return 'window0.dresscode.ai'
  }
  return location.hostname
}

export class UpdateStore {
  private stand: boolean
  private slug: string
  private state: State

  private window_update_id: TimeoutId = null!
  private widget_update_id: TimeoutId = null!
  private need_reload = false

  constructor(product: Product, stand: boolean) {
    this.stand = stand
    this.slug = product.product_id
    const version = app_version
    const stable = product.stable !== false
    this.state = { version, stable }
    makeAutoObservable(this)
  }

  startup() {
    when(() => this.canReload, () => this.reload())
    this.startWindowUpdateCheck()
    this.startWidgetUpdateCheck()
  }

  destroy() {
    clearInterval(this.window_update_id)
    clearInterval(this.widget_update_id)
  }

  private get host(): string {
    return getStableHost(this.state.stable)
  }

  private reload() {
    if (location.hostname != this.host) {
      location.hostname = this.host
    } else {
      location.reload()
    }
  }

  private get canReload(): boolean {
    if (!this.need_reload) return false
    if (this.stand) return !session.started
    return true
  }

  private startWindowUpdateCheck() {
    const update = async () => {
      if (this.need_reload) return
      const update = await api.getState(this.slug)
      if (!update) return
      const state = this.state
      const version = state.version !== update.version
      const host = location.hostname !== getStableHost(update.stable)
      this.state = update
      if (version || host) {
        console.warn('reload window', 'version', state.version, update.version,
          'host', location.hostname, getStableHost(update.stable))
        this.need_reload = true
      }
    }

    const enabled = env.production && !opt.irnby
    if (!enabled) return

    if (location.hostname === this.host) {
      this.window_update_id = setInterval(update, 60 * 1000)
    } else {
      console.warn('reload startup', 'host', location.hostname, this.host)
      this.need_reload = true
    }
  }

  private startWidgetUpdateCheck() {
    let version = ''

    const update = async () => {
      if (this.need_reload) return
      const update = window.showoff?.version || ''
      if (!update) return
      if (!version) {
        version = update
      } else if (version !== update) {
        console.warn('reload tryon', 'version', version, update)
        this.need_reload = true
      }
    }

    this.widget_update_id = setInterval(update, 1000)
  }
}
